import React from 'react';
import { Link } from 'react-router-dom';
import { brandText } from '../components/BrandText.jsx';
import { localizePath } from './localizedRoutes.js';

// External sites a text names; the language files mark them as {key} so every
// language links the same pages.
const externalLinks = {
  presidio: { href: 'https://presidio.dataprivacystack.org/', label: 'Microsoft Presidio' },
  spacy: { href: 'https://spacy.io/', label: 'spaCy' },
  flair: { href: 'https://flairnlp.github.io/', label: 'flair' }
};

// Pages of the homepage a text links to; the language files mark the linked
// words as [words](key), so the link follows the visitor's language.
const internalLinks = {
  finance: '/finance',
  veridion: '/veridion',
  agenticdev: '/agenticdev',
  idd: '/agenticdev',
  quantum: '/quantum'
};

export const withLinks = (text, language) => (text || '').split(/(\{\w+\}|\[[^\]]+\]\(\w+\))/).map((part, index) => {
  const external = /^\{\w+\}$/.test(part) && externalLinks[part.slice(1, -1)];
  if (external) {
    return <a key={index} href={external.href} target="_blank" rel="noopener noreferrer">{external.label}</a>;
  }
  const internal = /^\[([^\]]+)\]\((\w+)\)$/.exec(part);
  if (internal && internalLinks[internal[2]]) {
    return <Link key={index} to={localizePath(internalLinks[internal[2]], language)}>{internal[1]}</Link>;
  }
  return <React.Fragment key={index}>{brandText(part)}</React.Fragment>;
});
